import { ImpostoCreditadoStruct } from '../../structs/repo-dfse/imposto-creditado.struct';
import { ParcelaServicoTomadoStruct } from '../../structs/repo-dfse/parcela-servico-tomado.struct';
import { StatusFiscalNFSeEntradaEnum } from '../../../enums/repo-dfse/status-fiscal-nfse-entrada.enum';

export class ServicoTomadoCreateRequest {
  numeroNFSe: string = '';
  serieDps?: string | null;
  /** Chave de acesso da NFS-e (padrão nacional). Opcional no lançamento manual. */
  chaveAcesso?: string | null;
  idStatusFiscalNFSeEntrada: number = StatusFiscalNFSeEntradaEnum.Regular;
  datetimeEmissaoDps: string = '';
  dataExecucaoEntrada?: string | null;

  idPessoa?: number | null;
  tipoPessoaEmitente: number = 2;
  identificacaoFiscal?: string | null;
  nomeEmitente?: string | null;
  nomeFantasia?: string | null;
  inscricaoMunicipal?: string | null;
  logradouro?: string | null;
  numeroEndereco?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  codigoMunicipioIbge?: string | null;
  municipioNome?: string | null;
  uf?: string | null;
  cep?: string | null;
  telefone?: string | null;
  email?: string | null;

  descricaoServico: string = '';
  valorServico: number = 0;
  codigoNaturezaBaseCalculoCreditoSped?: string | null;
  codigoOrigemCreditoSped?: string | null;

  irBase?: number | null;
  irAliquota?: number | null;
  irValor?: number | null;
  inssBase?: number | null;
  inssAliquota?: number | null;
  inssValor?: number | null;
  issBase?: number | null;
  issAliquota?: number | null;
  issValor?: number | null;
  pisRetidoAliquota?: number | null;
  pisRetidoValor?: number | null;
  cofinsRetidoAliquota?: number | null;
  cofinsRetidoValor?: number | null;
  csllRetidoAliquota?: number | null;
  csllRetidoValor?: number | null;

  pisCreditado?: ImpostoCreditadoStruct | null;
  cofinsCreditado?: ImpostoCreditadoStruct | null;

  valorTotal: number = 0;
  valorLiquido: number = 0;

  condicaoPagamento?: string | null;
  idCategoriaFinanceira?: number | null;
  parcelas: ParcelaServicoTomadoStruct[] = [];

  observacaoInterna?: string | null;
}
